// extracted by mini-css-extract-plugin
module.exports = {"container":"DebtFormToggle_container__HrwB_","switcher":"DebtFormToggle_switcher__73G4z","item":"DebtFormToggle_item__AG4KX","activeItem":"DebtFormToggle_activeItem__rWSwB"};